/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import React, { useEffect } from "react";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import Spinner from "../components/spinner";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const OwnerDetails = ({
  handleNext,
  handleBack,
  ownerPreId,
  directors,
  setDirectors,
}) => {
  const location = useLocation();
  const { state } = location;
  const [isLoading, setIsLoading] = useState(false);
  const [clientName, setClientName] = useState("");
  const clientId = localStorage.getItem("clientId");
  const projectId = localStorage.getItem("projectId");
  const [errorMessages, setErrorMessages] = useState([]);
  const [data, setData] = useState();

  const validateField = (name, value) => {
    if (!value) {
      return `${name} is required`;
    }
    return null;
  };

  const validateImage = (name, image) => {
    if (!image) {
      return `${name} is required`;
    }

    return null;
  };

  const validateForm = () => {
    const errors = directors.map((director) => {
      const {
        directorName,
        // phoneNo,
        dob,
        gender,
        panNo,
        aadharNo,
        residenceAdd,
        category,
        panImage,
        aadharImage,
      } = director;

      return {
        directorName: validateField("directorName", directorName),
        // phoneNo: validateField("phoneNo", phoneNo),
        dob: validateField("dob", dob),
        gender: validateField("gender", gender),
        panNo: validateField("panNo", panNo),
        aadharNo: validateField("aadharNo", aadharNo),
        residenceAdd: validateField("residenceAdd", residenceAdd),
        category: validateField("category", category),
        panImage: validateImage("panImage", panImage),
        aadharImage: validateImage("aadharImage", aadharImage),
      };
    });

    setErrorMessages(errors);
    return errors.every((error) => Object.values(error).every((e) => !e));
  };

  const handleAddDirector = () => {
    setDirectors([
      ...directors,
      {
        clientId: clientId || state?.clientId,
        clientName: clientName,
        directorName: "",
        phoneNo: 0,
        dob: "",
        gender: "male",
        panNo: "",
        panImage: null,
        aadharNo: 0,
        aadharImage: null,
        category: "general",
        residenceAdd: "",
        physicallyHand: 0,
        authorized: 0
      },
    ]);
  };
  const handlePanImgChange = (e, index) => {
    const [file] = e.target.files;
    if (file && (file instanceof Blob || file instanceof File)) {
      const updatedDirectors = [...directors];
      updatedDirectors[index] = updatedDirectors[index] || {};
      updatedDirectors[index].panImage = file;

      const error = validateImage("panImage", file);
      setErrorMessages((prevErrors) => {
        const newErrors = [...prevErrors];
        newErrors[index] = { ...newErrors[index], panImage: error };
        return newErrors;
      });
      setDirectors(updatedDirectors);
    }
  };

  const handleAdharImgChange = (e, index) => {
    const [file] = e.target.files;
    if (file && (file instanceof Blob || file instanceof File)) {
      const updatedDirectors = [...directors];
      updatedDirectors[index] = updatedDirectors[index] || {};
      updatedDirectors[index].aadharImage = file;

      const error = validateImage("aadharImage", file);
      setErrorMessages((prevErrors) => {
        const newErrors = [...prevErrors];
        newErrors[index] = { ...newErrors[index], aadharImage: error };
        return newErrors;
      });

      setDirectors(updatedDirectors);
    }
  };

  const handleDateChange = (date, index) => {
    const updatedDirectors = [...directors];
    updatedDirectors[index] = {
      ...updatedDirectors[index],
      dob: date,
    };
    const errorMessage = validateField("dob", date);

    const updatedErrorMessages = [...errorMessages];
    updatedErrorMessages[index] = {
      ...updatedErrorMessages[index],
      dob: errorMessage,
    };

    setDirectors(updatedDirectors);
    setErrorMessages(updatedErrorMessages);
  };

  const handleDirectorDetailsChange = (e, index) => {
    const { name, value, type, checked } = e.target;
    const updatedDirectors = [...directors];
    updatedDirectors[index] = {
      ...updatedDirectors[index],
      [name]: type === "checkbox" ? (checked ? 1 : 0) : value,
    };

    const error = validateField(name, value);
    setErrorMessages((prevErrors) => {
      const newErrors = [...prevErrors];
      newErrors[index] = { ...newErrors[index], [name]: error };
      return newErrors;
    });

    setDirectors(updatedDirectors);
  };

  const handleOwnerSubmit = async () => {
    const isValid = validateForm();

    if (isValid) {
      try {
        setIsLoading(true);
        const formDataArray = directors.map((director, index) => {
          const formData = new FormData();
          const originalDate = new Date(director.dob);
          const ConvertDOBDate = originalDate.toISOString().split("T")[0];

          formData.append("clientId", clientId || state?.clientId);
          formData.append("clientName", clientName);
          formData.append(`directorName`, director.directorName);
          formData.append(`phoneNo`, director.phoneNo);
          formData.append(`dob`, ConvertDOBDate);
          formData.append(`gender`, director.gender);
          formData.append(`panNo`, director.panNo);
          formData.append(`panImage`, director.panImage);
          formData.append(`residenceAdd`, director.residenceAdd);
          formData.append(`aadharNo`, director.aadharNo);
          formData.append(`aadharImage`, director.aadharImage);
          formData.append(`category`, director.category);
          formData.append("physicallyHand", director.physicallyHand);
          formData.append("authorized", director.authorized);
          return formData;
        });

        if (
          (ownerPreId === undefined || ownerPreId === null) &&
          state === null
        ) {
          const responses = await Promise.all(
            formDataArray.map((formData) =>
              axios.post(
                `${process.env.REACT_APP_API_URL}/create-owner`,
                formData,
                {
                  headers: {
                    Authorization: `Bearer ${localStorage.getItem("signIn")}`,
                    "Content-Type": "multipart/form-data",
                  },
                }
              )
            )
          );
          const allRequestsSuccessful = responses.every(
            (response) => response.status === 201
          );
          if (allRequestsSuccessful) {
            const allIds = responses.map((response) => response.data.result.id);
            localStorage.setItem("OwnerId", JSON.stringify(allIds));
            handleNext();
          }
        } else {
          if (
            (ownerPreId === undefined || ownerPreId === null) &&
            state &&
            state.editMode === true
          ) {
            try {
              const responses = await Promise.all(
                directors.map(async (val, index) => {
                  if (val.id) {
                    return await axios.put(
                      `${process.env.REACT_APP_API_URL}/update-owner/${val.id}`,
                      formDataArray[index],
                      {
                        headers: {
                          Authorization: `Bearer ${localStorage.getItem(
                            "signIn"
                          )}`,
                          "Content-Type": "multipart/form-data",
                        },
                      }
                    );
                  } else {
                    return await axios.post(
                      `${process.env.REACT_APP_API_URL}/create-owner`,
                      formDataArray[index],
                      {
                        headers: {
                          Authorization: `Bearer ${localStorage.getItem(
                            "signIn"
                          )}`,
                          "Content-Type": "multipart/form-data",
                        },
                      }
                    );
                  }
                })
              );

              const allIds = responses.map(
                (response) => response.data.result.id
              );
              localStorage.setItem("OwnerId", JSON.stringify(allIds));

              handleNext();
            } catch (error) {
              console.error("Error updating or creating owners:", error);
            }
          } else {
            try {
              const response = await Promise.all(
                directors.map(async (val, directorIndex) => {
                  if (val.id) {
                    return await axios.put(
                      `${process.env.REACT_APP_API_URL}/update-owner/${val.id}`,
                      formDataArray[directorIndex],
                      {
                        headers: {
                          Authorization: `Bearer ${localStorage.getItem(
                            "signIn"
                          )}`,
                          "Content-Type": "multipart/form-data",
                        },
                      }
                    );
                  } else {
                    return await axios.post(
                      `${process.env.REACT_APP_API_URL}/create-owner`,
                      formDataArray[directorIndex],
                      {
                        headers: {
                          Authorization: `Bearer ${localStorage.getItem(
                            "signIn"
                          )}`,
                          "Content-Type": "multipart/form-data",
                        },
                      }
                    );
                  }
                })
              );

              const allIds = response.flat().map((res) => res.data.result.id);
              localStorage.setItem("OwnerId", JSON.stringify(allIds));

              handleNext();
            } catch (error) {
              console.error("Error updating or creating owners:", error);
            }
          }
        }
      } catch (error) {
        console.error("Error submitting owner data:", error);
      } finally {
        setIsLoading(false);
      }
    }
  };
  const handleData = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/get-client-byId/${
        clientId || state?.clientId || null
      }`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("signIn")}`,
        },
      }
    );
    const clients = response.data.result[0];

    const projectRes = await axios.get(
      `${process.env.REACT_APP_API_URL}/get-project-byId/${
        projectId || state?.projectId || null
      }`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("signIn")}`,
        },
      }
    );
    const project = projectRes.data.result[0];
    const newClientName = clients?.nameFirm + "_" + String(project?.id);
    setClientName(newClientName);
    setData(clients);
  };

  const formatDateForDisplay = (dateFromDatabase) => {
    const dateObject = new Date(dateFromDatabase);
    dateObject.setDate(dateObject.getDate() - 0);
    dateObject.setHours(18, 30, 0, 0);
    return dateObject;
  };

  const handleEditData = async () => {
    try {
      if (ownerPreId && ownerPreId.length > 0) {
        const directorArray = await Promise.all(
          ownerPreId.map(async (id) => {
            const response = await axios.get(
              `${process.env.REACT_APP_API_URL}/get-owner-byId/${id}`,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("signIn")}`,
                },
              }
            );
            const directorsData = response.data.result;

            const formattedDirectors = directorsData.map((director) => ({
              ...director,
              dob: formatDateForDisplay(director.dob),
            }));

            return formattedDirectors;
          })
        );

        setDirectors(directorArray.flat());
      } else if (state && state.editMode) {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/get-all-owner`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("signIn")}`,
            },
          }
        );
        const owners = response.data.result;
        const filterOwner = owners.filter(
          (own) => own.clientId === state?.clientId
        );

        const directorIds = filterOwner.map((owner) => owner.id);
        localStorage.setItem("OwnerId", JSON.stringify(directorIds));
        const formattedDir = filterOwner.map((director) => ({
          ...director,
          dob: formatDateForDisplay(director.dob),
        }));

        setDirectors(formattedDir);
      }
    } catch (error) {
      console.error("Error fetching director data:", error);
    }
  };

  useEffect(() => {
    handleData();
  }, [clientId, projectId, state?.clientId]);

  useEffect(() => {
    handleEditData();
  }, [state, ownerPreId]);

  return (
    <div>
      {isLoading ? (
        <Spinner />
      ) : (
        <div className="container card card-body">
          <form>
            {directors &&
              directors.map((director, index) => (
                <div key={index}>
                  <div style={{ textAlign: "start" }}>
                    <h2>Owner Details</h2>
                  </div>
                  <div className="form-row">
                    <div className="form-group col-md-6">
                      <label>Name Director</label>
                      <input
                        type="text"
                        name="directorName"
                        className={`form-control ${
                          errorMessages[index]?.directorName ? "is-invalid" : ""
                        }`}
                        value={directors[index].directorName || ""}
                        onChange={(e) => handleDirectorDetailsChange(e, index)}
                      />
                      {errorMessages[index]?.directorName && (
                        <p className="invalid-feedback">
                          {errorMessages[index].directorName}
                        </p>
                      )}
                    </div>
                    <div className="form-group col-md-6">
                      <label>Phone Number</label>
                      <input
                        type="number"
                        name="phoneNo"
                        className={`form-control ${
                          errorMessages[index]?.phoneNo ? "is-invalid" : ""
                        }`}
                        onChange={(e) => handleDirectorDetailsChange(e, index)}
                        value={directors[index].phoneNo}
                      />
                      {errorMessages[index]?.phoneNo && (
                        <p className="invalid-feedback">
                          {errorMessages[index].phoneNo}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group col-md-6">
                      <label>Date of Birth</label>
                      <div className="date-picker-container">
                        <DatePicker
                          className={`form-control ${
                            errorMessages[index]?.dob ? "is-invalid" : ""
                          }`}
                          showYearDropdown
                          showMonthDropdown
                          selected={directors[index]?.dob}
                          onChange={(date) => handleDateChange(date, index)}
                          dateFormat="dd/MM/yyyy"
                          placeholderText="DD/MM/YYYY"
                        />
                      </div>
                      {errorMessages[index]?.dob && (
                        <p className="invalid-message">
                          {errorMessages[index].dob}
                        </p>
                      )}
                    </div>
                    <div className="form-group col-md-6">
                      <label>Gender</label>

                      <select
                        className={`custom-select mr-sm-2 ${
                          errorMessages[index]?.gender ? "is-invalid" : ""
                        }`}
                        name="gender"
                        value={directors[index].gender}
                        onChange={(e) => handleDirectorDetailsChange(e, index)}
                      >
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                      </select>
                      {errorMessages[index]?.gender && (
                        <p className="invalid-feedback">
                          {errorMessages[index].gender}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group col-md-6">
                      <label>Pan Number</label>
                      <input
                        type="text"
                        className={`form-control ${
                          errorMessages[index]?.panNo ? "is-invalid" : ""
                        }`}
                        name="panNo"
                        value={directors[index].panNo}
                        onChange={(e) => handleDirectorDetailsChange(e, index)}
                      />
                      {errorMessages[index]?.panNo && (
                        <p className="invalid-feedback">
                          {errorMessages[index].panNo}
                        </p>
                      )}
                    </div>
                    <div className="form-group col-md-6">
                      <label>Aadhar Number</label>
                      <input
                        type="number"
                        className={`form-control ${
                          errorMessages[index]?.aadharNo ? "is-invalid" : ""
                        }`}
                        name="aadharNo"
                        value={directors[index].aadharNo}
                        onChange={(e) => handleDirectorDetailsChange(e, index)}
                      />
                      {errorMessages[index]?.aadharNo && (
                        <p className="invalid-feedback">
                          {errorMessages[index].aadharNo}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group col-md-6">
                      <label>Pan Image</label>
                      <input
                        type="file"
                        className={`form-control ${
                          errorMessages[index]?.panImage ? "is-invalid" : ""
                        }`}
                        name="panImage"
                        onChange={(e) => handlePanImgChange(e, index)}
                      />
                      {errorMessages[index]?.panImage && (
                        <p className="invalid-feedback">
                          {errorMessages[index].panImage}
                        </p>
                      )}
                    </div>
                    <div className="form-group col-md-6">
                      <label>Aadhar Image</label>
                      <input
                        type="file"
                        className={`form-control ${
                          errorMessages[index]?.aadharImage ? "is-invalid" : ""
                        }`}
                        name="aadharImage"
                        onChange={(e) => handleAdharImgChange(e, index)}
                      />
                      {errorMessages[index]?.aadharImage && (
                        <p className="invalid-feedback">
                          {errorMessages[index].aadharImage}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="col-md-6">
                      {directors[index].panImage &&
                      directors[index].panImage instanceof Blob ? (
                        <a
                          href={URL.createObjectURL(directors[index].panImage)}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {directors[index].panImage?.name}
                        </a>
                      ) : (
                        <a
                          href={
                            process.env.REACT_APP_BASE_URL +
                            directors[index].panImage
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {directors[index].panImage
                            ?.split("/")
                            .pop()
                            .split("-")
                            .pop()
                            .replace(/^\d+/, "")}
                        </a>
                      )}
                    </div>
                    <div className="col-md-6">
                      {directors[index].aadharImage &&
                      directors[index].aadharImage instanceof Blob ? (
                        <a
                          href={URL.createObjectURL(
                            directors[index].aadharImage
                          )}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {directors[index].aadharImage?.name}
                        </a>
                      ) : (
                        <a
                          href={
                            process.env.REACT_APP_BASE_URL +
                            directors[index].aadharImage
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {directors[index].aadharImage
                            ?.split("/")
                            .pop()
                            .split("-")
                            .pop()
                            .replace(/^\d+/, "")}
                        </a>
                      )}
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group col-md-6">
                      <label>Residence Address</label>
                      <input
                        type="text"
                        className={`form-control ${
                          errorMessages[index]?.residenceAdd ? "is-invalid" : ""
                        }`}
                        name="residenceAdd"
                        value={directors[index].residenceAdd}
                        onChange={(e) => handleDirectorDetailsChange(e, index)}
                      />
                      {errorMessages[index]?.residenceAdd && (
                        <p className="invalid-feedback">
                          {errorMessages[index].residenceAdd}
                        </p>
                      )}
                    </div>
                    <div className="form-group col-md-6">
                      <label>Catagory</label>
                      <select
                        className={`custom-select mr-sm-2 ${
                          errorMessages[index]?.category ? "is-invalid" : ""
                        }`}
                        name="category"
                        value={directors[index].category}
                        onChange={(e) => handleDirectorDetailsChange(e, index)}
                      >
                        <option value="general">GENERAL</option>
                        <option value="sc">SC</option>
                        <option value="st">ST</option>
                        <option value="obc">OBC</option>
                      </select>
                      {errorMessages[index]?.category && (
                        <p className="invalid-feedback">
                          {errorMessages[index].category}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group form-check col-md-6 d-flex">
                      <input
                        type="checkbox"
                        name="physicallyHand"
                        className="form-check"
                        checked={directors[index].physicallyHand === 1}
                        onChange={(e) => handleDirectorDetailsChange(e, index)}
                      />
                      <label className="form-check-label fw-semibold">
                        &nbsp;Are you physically handicapped?
                      </label>
                    </div>
                    <div className="form-group form-check col-md-6 d-flex">
                      <input
                        type="checkbox"
                        name="authorized"
                        className="form-check"
                        checked={directors[index].authorized === 1}
                        onChange={(e) => handleDirectorDetailsChange(e, index)}
                      />
                      <label className="form-check-label fw-semibold">
                        &nbsp;Authorized?
                      </label>
                    </div>
                  </div>
                </div>
              ))}
            <div className="d-grid gap-2 d-md-flex justify-content-md-end">
              <div className="form-group text-center">
                <button
                  type="button"
                  style={{ border: "1px solid gray", marginRight: "10px" }}
                  className="btn btn-default btn res-btn-gray"
                  onClick={handleAddDirector}
                  disabled={data?.typeFirm === "proprietor"}
                >
                  Add Directors
                </button>
                <button
                  type="button"
                  style={{ border: "1px solid gray", marginRight: "10px" }}
                  className="btn btn-default btn res-btn-gray"
                  onClick={() => handleBack()}
                >
                  Previous
                </button>
                <button
                  type="button"
                  style={{ border: "1px solid gray" }}
                  className="btn btn-default col-xs-offset-1"
                  onClick={handleOwnerSubmit}
                >
                  Next
                </button>
              </div>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default OwnerDetails;
